﻿let URI = require('urijs');
let _ = require('lodash');


const enterKeyCode = 13;

let SearchBox = function (customOptions) {
    let element = customOptions.element;
    let input = customOptions.input;
    let searchButton = customOptions.searchButton;

    let url = element.data("results-url") || (window.location.origin + window.location.pathname);

    let onSearch = (event) => {
        event.preventDefault();
        let query = buildQuery(element, input);

        let destination = URI(url).query(query);
        window.location.href = destination;
    };

    searchButton.click(onSearch);
    input.keypress(e => {
        if (e.keyCode === enterKeyCode) {
            onSearch(e);
        }
    });
};

function buildQuery(element, input) {
    let data = element.data();
    let params = _.reduce(data, (result, value, key) => {
        if(key.startsWith("param")) {
            let paramName = key.replace("param", "").toLowerCase();
            result[paramName] = value;
        }
        return result;
    }, {});

    let inputValue = input.val();
    let query = _.assign(params, {
        searchQuery: inputValue
    });

    return query;
}

module.exports = SearchBox;